<template>
    <b-popover id="popover-filtros" ref="popover" target="btn-filtro-ancora" triggers="click blur" placement="bottom" custom-class="popover-filtros">
        <template #title>
            <div class="text-center font-weight-bold">Filtrar por</div>
        </template>

        <form class="p-2 container-fluid" @submit.prevent="aplicarFiltros">

            <div class="row align-items-center">
                <div class="col-12">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="customSwitch1" v-model="filtros.conteudoObrigatorio">
                        <label class="custom-control-label pl-3" for="customSwitch1">Conteúdo obrigatório</label>
                    </div>
                </div>
            </div>

            <hr />

            <div class="row mb-2">
                <div class="col-12"><strong>Período</strong></div>
            </div>

            <div class="row">
                <div class="col-6">
                    <div class="form-check">
                        <input class="form-check-input" type="radio" v-model="filtros.filtroPeriodo" value="semana" id="radioSemana">
                        <label class="form-check-label ml-2" for="radioSemana">Última semana</label>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-check">
                        <input class="form-check-input" type="radio" v-model="filtros.filtroPeriodo" value="mes" id="radioMes">
                        <label class="form-check-label ml-2" for="radioMes">Último mês</label>
                    </div>
                </div>
            </div>

            <div class="form-check mt-2">
                <input class="form-check-input" type="radio" v-model="filtros.filtroPeriodo" value="personalizado" id="radioPersonalizado">
                <label class="form-check-label ml-2" for="radioPersonalizado">Personalizado</label>
            </div>

            <div v-if="filtros.filtroPeriodo === 'personalizado'" class="mt-3 animate-in">
                <div class="row d-flex align-items-center">
                    <div class="col-5">
                        <input type="date" v-model="filtros.dataInicio" class="form-control form-control-sm">
                    </div>
                    <div class="col-2 text-center small text-muted">até</div>
                    <div class="col-5">
                        <input type="date" v-model="filtros.dataFim" class="form-control form-control-sm">
                    </div>
                </div>
            </div>

            <hr />

            <div class="d-flex justify-content-between align-items-center mt-3">
                <button type="button" class="btn-limpar-filtros text-success" @click="limparTodosFiltros">
                    <i class="fas fa-history mr-1"></i> Limpar tudo
                </button>

                <div class="d-flex">
                    <button type="button" class="btn btn-outline-success btn-sm px-3" @click="fecharPopover">
                        Cancelar
                    </button>
                    <button type="submit" class="btn btn-success btn-sm px-3 ml-2">
                        Aplicar
                    </button>
                </div>
            </div>
        </form>
    </b-popover>
</template>

<script>
export default {
    data() {
        return {
            filtros: {
                conteudoObrigatorio: false,
                filtroPeriodo: 'semana',
                dataInicio: '',
                dataFim: ''
            }
        }
    },
    methods: {
        limparTodosFiltros() {
            this.filtros = {
                conteudoObrigatorio: false,
                filtroPeriodo: 'semana',
                dataInicio: '',
                dataFim: ''
            };
        },
        fecharPopover() {
            this.$refs.popover.$emit('close');
        },
        aplicarFiltros() {
            this.$emit('filtrar', { ...this.filtros });
            this.fecharPopover();
        }
    }
}
</script>

<style scoped>

.custom-switch .custom-control-label::before {
    width: 2.5rem; /* Largura da cápsula */
    height: 1.5rem; /* Altura da cápsula */
    border-radius: 1rem;
}

/* Redimensiona a bolinha interna */
.custom-switch .custom-control-label::after {
    width: calc(1.5rem - 4px); /* Altura da cápsula menos as bordas */
    height: calc(1.5rem - 4px);
    border-radius: 50%;
}

/* Ajusta o posicionamento da bolinha quando marcado */
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
    transform: translateX(1rem); /* Move a bolinha para a direita */
}

/* Ajusta o espaçamento do texto ao lado */
.custom-switch .custom-control-label {
    padding-left: 3rem; 
    padding-top: 0.2rem;
}
.btn-limpar-filtros {
    padding: 4px 8px;
    color: #6C757D;
    border: none;
    background-color: transparent;
    font-family: "Trebuchet MS";
    font-size: 12px;
    display: inline-block;
}

form {
    overflow-x: hidden;
}

.btn-limpar-filtros:hover {
    background-color: #CDDDDC;
}

.popover-filtros {
    color: #212529;
    font-family: "Trebuchet MS";
    font-size: 16px;    
    margin-left: 30px;
}



.popover-filtros .btn-sm {
    font-size: 14px !important;
    padding: 6px 12px;
}

.btn-success {
    background-color: #157347 !important;
    border-color: #157347 !important;
    color: #fff !important;
}

.btn-success:hover,
.btn-success:focus {
    background-color: #115c39 !important;
    border-color: #115c39 !important;
}

.btn-outline-success {
    color: #007A4A !important;
    border-color: #007A4A !important;
}

.btn-outline-success:hover {
    background-color: #007A4A !important;
    color: #fff !important;
}


.text-success {
    color: #007A4A !important;
}

/* Garante a borda visível nos inputs de data */
.form-control {
    border: 1px solid #ced4da !important; /* Cor cinza padrão do Bootstrap */
    background-color: #fff !important;
    border-radius: 4px !important;
}

/* Efeito ao clicar no campo (focus) */
.form-control:focus {
    border-color: #86b7fe !important;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25) !important;
    outline: 0;
}

/* Ajuste específico para inputs menores se necessário */
.form-control-sm {
    height: calc(1.5em + 0.5rem + 2px);
    padding: 0.25rem 0.5rem;
}

</style>

<style>
.popover-filtros .popover-header {
    color: #212529;
    background-color: transparent;
    text-align: center !important;
    font-family: "Trebuchet MS";
    font-size: 20px;
    padding: 20px;
}

.popover-filtros.popover {
    max-width: 500px !important;
}

.popover-filtros .popover-body {
    padding: 20px;
}

.popover-filtros.popover {
    width: 500px !important;
    max-width: 90vw !important;
    border-radius: 8px;
}

.popover-filtros * {
    box-sizing: border-box;
}
</style>